export default "__VITE_ASSET__DFipfZoJ__"